import React, { useEffect, useState } from "react";

import Board from "./Board";

import { CircularProgress } from "@mui/material";

const Table = (props) => {
  const { search = "", banners = [], isLoading, refetch } = props;
  console.log("butters", banners);

  return (
    <div>
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Imagem</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {!isLoading &&
              banners?.map((value, index) => (
                <Board
                  key={index}
                  id={value?.id}
                  banner={value?.image}
                  refetch={refetch}
                />
              ))}
          </tbody>
        </table>
      </div>
      <div className="w100 flex jcc">
        <CircularProgress hidden={!isLoading} />
        <p hidden={banners?.length !== 0 || isLoading}>
          Não há depoimentos cadastrados
        </p>
      </div>
      {/* <Pagination
        className={maxPage == 1 ? "hide" : ""}
        style={{ display: "flex", justifyContent: "flex-end" }}
        count={maxPage}
        value={page}
        onChange={(_, value) => SetPage(value)}
      /> */}
    </div>
  );
};

export default Table;
